import React, { useState } from 'react';
import { Flex, Button, Modal } from '@olist/design-system';
import { AdvancedFilterOutline } from '@olist/design-system-icons';

function ModalFooter({ onClean, onClose, onFilter, modal, }) {
    var _a, _b, _c;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variation: "secondary", onClick: onClose }, (_a = modal === null || modal === void 0 ? void 0 : modal.cancelButtonText) !== null && _a !== void 0 ? _a : 'cancelar'),
        React.createElement(Flex, { flex: 1, justifyContent: "flex-end" },
            React.createElement(Button, { variation: "secondary", onClick: onClean }, (_b = modal === null || modal === void 0 ? void 0 : modal.cleanButtonText) !== null && _b !== void 0 ? _b : 'limpar filtros'),
            React.createElement(Button, { onClick: onFilter, marginLeft: "16px" }, (_c = modal === null || modal === void 0 ? void 0 : modal.filterButtonText) !== null && _c !== void 0 ? _c : 'filtrar'))));
}
function FilterModal({ onClose: onCloseProps, onClean: onCleanProps, onFilter: onFilterProps, children, triggerText, triggerVariation = 'secondary', modal, }) {
    var _a;
    const [isOpen, setIsOpen] = useState(false);
    const onClose = () => {
        setIsOpen(false);
        onCloseProps === null || onCloseProps === void 0 ? void 0 : onCloseProps();
    };
    const onFilter = () => {
        onFilterProps();
        onClose();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { alignItems: "center", "data-testid": "filter-modal-trigger" },
            React.createElement(Button, { variation: triggerVariation, onClick: () => setIsOpen(true), iconLeft: AdvancedFilterOutline }, triggerText !== null && triggerText !== void 0 ? triggerText : 'filtrar')),
        React.createElement(Modal, { isOpen: isOpen, onClose: onClose, title: (_a = modal === null || modal === void 0 ? void 0 : modal.title) !== null && _a !== void 0 ? _a : 'Filtrar', size: "large", body: React.createElement(React.Fragment, null, children), footer: React.createElement(ModalFooter, { onClose: onClose, onClean: onCleanProps, onFilter: onFilter, modal: {
                    cancelButtonText: modal === null || modal === void 0 ? void 0 : modal.cancelButtonText,
                    cleanButtonText: modal === null || modal === void 0 ? void 0 : modal.cleanButtonText,
                    filterButtonText: modal === null || modal === void 0 ? void 0 : modal.filterButtonText,
                } }) })));
}

export { FilterModal };
